// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsControl_container__2J5CJ","overlay":"SettingsControl_overlay__17RIc"};